import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "24",
  fill: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12 9a1 1 0 0 1 1 1v4a1 1 0 1 1-2 0v-4a1 1 0 0 1 1-1Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M12.895 5.025a1 1 0 0 0-1.79 0L4.343 18.553A1 1 0 0 0 5.236 20h13.528a1 1 0 0 0 .895-1.447L12.895 5.025Zm-3.578-.894c1.105-2.211 4.26-2.211 5.367 0l6.763 13.528c.998 1.995-.453 4.341-2.683 4.341H5.236c-2.23 0-3.68-2.346-2.683-4.341L9.317 4.13Z",
  "clip-rule": "evenodd"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }